import React from 'react';

const InitialLoadingContext = React.createContext();

export default InitialLoadingContext;
